import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "./oEscritorio.css";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import Whatsapp from "../../components/whatsapp/whatsapp";
import SEO from "../../components/seo/SEO";

import Mapa from "../../assets/images/World Map.png";
import { getBreadcrumbSchema } from "../../utils/schemas";

function OEscritorio() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  const breadcrumbs = [
    { name: "Home", url: "https://antoniosaldanhaadvocacia.com.br/" },
    {
      name: "O Escritório",
      url: "https://antoniosaldanhaadvocacia.com.br/o-escritorio",
    },
  ];

  return (
    <div className="container-fluid p-0 o-escritorio">
      <SEO
        title="O Escritório | Antonio Saldanha Advocacia"
        description="Conheça nossa estrutura, visão estratégica, valores e atuação jurídica em todo o território nacional."
        canonical="https://antoniosaldanhaadvocacia.com.br/o-escritorio"
        schemaJson={getBreadcrumbSchema(breadcrumbs)}
      />

      <Navbar />

      <main className="py-4">
        {/* Banner Institucional */}
        <section className="container mt-4 d-flex flex-column align-items-center">
          <span className="badge badge-dourado mb-2" data-aos="fade-up">
            Institucional
          </span>
          <h1 className="titulos-secoes text-center" data-aos="fade-up">
            O Escritório
          </h1>

          <div
            className="oescritorio-text-wrapper mt-4 bg-white p-4 p-md-5 rounded-3 shadow-sm border"
            data-aos="fade-up"
          >
            <p className="texto-o-escritorio lead text-center text-dark font-subtitulo mb-3">
              Antonio Saldanha Advocacia nasce com a proposta de oferecer um
              serviço moderno, estratégico e transparente. Em ascensão no
              cenário jurídico, o escritório combina técnica apurada, atuação
              ágil e compromisso absoluto com a excelência, proporcionando
              soluções eficazes e alinhadas às necessidades de cada cliente. Com
              uma prática focada em entregar segurança, clareza e direcionamento
              jurídico, o escritório Antonio Saldanha Advocacia se destaca pela
              postura ética, pela comunicação transparente e pela capacidade de
              transformar desafios em oportunidades. Nosso trabalho é pautado
              por estudo constante, visão de futuro e dedicação integral em cada
              demanda.
            </p>

            <p className="texto-o-escritorio text-center text-secondary mb-0">
              Mais do que um escritório de advocacia, somos um parceiro
              comprometido com o sucesso dos nossos clientes — conduzindo cada
              caso com responsabilidade, estratégia e profissionalismo.
            </p>
          </div>
        </section>

        {/* Atuação Nacional */}
        <section className="container mt-5 d-flex flex-column align-items-center">
          <h2 className="titulos-secoes text-center" data-aos="fade-up">
            Atuação em Todo o Brasil
          </h2>

          <div
            className="mapa-wrapper my-4 p-3 bg-white rounded-3 shadow-sm border w-100 text-center"
            data-aos="fade-up"
          >
            <img
              src={Mapa}
              alt="Mapa de atuação nacional do escritório Antonio Saldanha Advocacia"
              className="img-mapa-mundi img-fluid rounded-2"
              loading="lazy"
            />
          </div>

          <div className="oescritorio-text-wrapper bg-white p-4 p-md-5 rounded-3 shadow-sm border">
            <p
              className="texto-o-escritorio text-center text-secondary mb-0"
              data-aos="fade-up"
            >
              O escritório Antonio Saldanha Advocacia possui atuação em todo o
              território nacional, oferecendo suporte jurídico eficiente a
              clientes de qualquer região do Brasil. Independentemente do estado
              ou cidade, o escritório está preparado para atender de forma ágil,
              moderna e totalmente integrada, assegurando que cada cliente
              receba orientação especializada onde quer que esteja.
            </p>
          </div>
        </section>

        {/* Missão, Visão e Valores */}
        <section className="container mt-5 mb-4">
          <div className="cards-wrapper">
            <div className="row g-4 justify-content-center">
              <div className="col-12 col-md-4">
                <div
                  className="card card-personalizado text-center rounded-3 p-4 border-0 h-100 shadow-sm"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <div className="icone-mvv mb-3">
                    <svg
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="text-dourado"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      />
                    </svg>
                  </div>
                  <h3 className="fs-3 fw-bold text-dark mb-3 font-titulo">
                    Missão
                  </h3>
                  <p className="texto-cards text-muted font-sm mb-0">
                    Oferecer soluções jurídicas estratégicas, eficientes e
                    personalizadas, atuando com excelência, agilidade e ética
                    para garantir segurança e resultados concretos aos nossos
                    clientes.
                  </p>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div
                  className="card card-personalizado text-center rounded-3 p-4 border-0 h-100 shadow-sm"
                  data-aos="zoom-in"
                  data-aos-delay="200"
                >
                  <div className="icone-mvv mb-3">
                    <svg
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="text-dourado"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  </div>
                  <h3 className="fs-3 fw-bold text-dark mb-3 font-titulo">
                    Visão
                  </h3>
                  <p className="texto-cards text-muted font-sm mb-0">
                    Tornar-se referência em advocacia moderna e de alta
                    performance, expandindo nossa atuação e consolidando Antonio
                    Saldanha Advocacia como um escritório admirado pela
                    qualidade técnica, inovação e compromisso com o cliente.
                  </p>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div
                  className="card card-personalizado text-center rounded-3 p-4 border-0 h-100 shadow-sm"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                >
                  <div className="icone-mvv mb-3">
                    <svg
                      width="32"
                      height="32"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      className="text-dourado"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                      />
                    </svg>
                  </div>
                  <h3 className="fs-3 fw-bold text-dark mb-3 font-titulo">
                    Valores
                  </h3>
                  <p className="texto-cards text-muted font-sm mb-0">
                    Excelência em cada entrega. Ética e integridade em todas as
                    relações. Transparência na comunicação. Coragem para
                    enfrentar desafios. Inovação contínua. Compromisso com cada
                    cliente. Humanidade no olhar e na atuação.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default OEscritorio;
